exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nH0ZxgqCNZFALean66kPt{padding:45px 120px}._4V-u27tJhJIRk3GqLWR-0{max-width:720px;max-height:300px}._22Ia2A1q5fWcka5M0XXQvT{color:#757575;height:84px;width:84px;display:flex;align-items:center;justify-content:center;margin-bottom:20px}._6FUrFNu8kG0P5bdMVvFJv{margin-top:20px}\n", ""]);

// Exports
exports.locals = {
	"privatePage": "nH0ZxgqCNZFALean66kPt",
	"card": "_4V-u27tJhJIRk3GqLWR-0",
	"icon": "_22Ia2A1q5fWcka5M0XXQvT",
	"buttons": "_6FUrFNu8kG0P5bdMVvFJv"
};